<div id="sp_scrolltop" class="sp-scrolltop">
    <i class="la la-angle-up"></i>
</div>